<template>
  <div class="page-content">
    <el-pagination
      v-if="current === ''"
      class="pages"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :pager-count="pagerCount" 
      :total="total">
    </el-pagination>
    <el-pagination
      v-if="current === 'tenchCenter'"
      class="pages"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize2"
      :pager-count="5" 
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    computed: {
      cPage() {
        return this.currentPage
      }
    },
    props: {
      total: {    //总数目
        type: Number,
        default: 0
      },
      currentPage: {  //当前页
        type: Number,
        default: 1
      },
      pagerCount:{
        type: Number,
        default: 5
      },
      allPage: {
        type: Number,
        default: 1
      },
      pageSize:{
        type: Number,
        default: 30
      },
      pageSize2:{
        type: Number,
        default: 20
      },
      current:{
        type: String,
        default: ''
      }
    },
    methods: {
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.$emit('page-size', val)
      },
      handleCurrentChange(val) {
        this.$emit('current-page', val)
      }
    },
    mounted() {
      window.$('.page-content .el-input__inner').keyup(function () {
        window.$(this).val(window.$(this).val().replace(/[^0-9.]/g, ''))
      }).bind('paste', function () {
        window.$(this).val(window.$(this).val().replace(/[^0-9.]/g, ''))
      }).css('ime-mode', 'disabled')
    },
    data() {
      return {}
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .page-content
    position: relative
    top: -1px
    z-index: 10
    width: 100%
    height : 30px
    background: #fff
    text-align: center
    padding-bottom: 10px
    .pages
      margin-right: 40px
      height : 30px

  .page-title
    position: absolute
    right: 460px
    top: 16px
</style>



// WEBPACK FOOTER //
// page.vue?76d376f8